module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2166562"
    }
  }, [_c('b', [_vm._v("SPICY BLACK BEAN SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2167062"
    }
  }, [_c('b', [_c('i', [_vm._v("Canned beans make this soup a snap to prepare, and a zingy blend of spices gives it south-of the-border sass.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2168262"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes Cook: 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2168762"
    }
  }, [_vm._v("1 tablespoon vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2169062"
    }
  }, [_vm._v("1 medium onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2169362"
    }
  }, [_vm._v("2 garlic cloves, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2169662"
    }
  }, [_vm._v("2 teaspoons chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2169962"
    }
  }, [_vm._v("1 teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2170262"
    }
  }, [_vm._v("¼ teaspoon crushed red pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2171262"
    }
  }, [_vm._v("2 cans (15 to 19 ounces each) black beans, "), _c('br'), _vm._v(" rinsed and drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2171862"
    }
  }, [_vm._v("2 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2172162"
    }
  }, [_vm._v("1 can (14½ ounces) chicken broth or")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2173362"
    }
  }, [_vm._v("1¾ cups Chicken Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2174562"
    }
  }, [_vm._v("¼ cup coarsely chopped fresh cilantro "), _c('br'), _vm._v(" lime wedges")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2175962"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 3-quart saucepan, heat oil over medium heat. Add onion and cook, stirring occasionally, until tender, 5 to 8 minutes. Stir in garlic, chili powder, cumin, and crushed red pepper; cook 30 seconds. Stir in beans, water, and broth; heat to boiling over high heat. Reduce heat and simmer 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2178662"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Spoon one-third of mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour puree into bowl. Repeat with remaining mixture. Sprinkle with cilantro and serve with wedges of lime. Makes about 6⅔ cups or 6 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2182162"
    }
  }, [_vm._v("Each serving: About 137 calories, 7g protein, 19g carbohydrate, 4g total fat (0g saturated), 0mg cholesterol, 563mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593f6ca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c63_r1.vue
// module id = 255
// module chunks = 0